import React from "react";
import { checkIsEditing } from "../../../../Utils/sitecoreUtils";
import "./index.css";
const Error = props => {
  const isEditing = checkIsEditing(props.sitecoreContext);
  const contextError = (() => {
    switch (props.contextError) {
      case "rendering":
        {
          return "Verify datasource parameters";
        }
      case "placeholder":
        {
          return "Verify placeholder children parameters";
        }
      case "route":
        {
          return "Verify component has been used on correct page template";
        }
      default:
        {
          break;
        }
    }
  })();
  if (isEditing) {
    return /*#__PURE__*/React.createElement("div", {
      className: "rendering-error wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rendering-error__inner"
    }, /*#__PURE__*/React.createElement("p", {
      className: "rendering-error__msg"
    }, "Rendering error in component ", props.rendering.componentName), /*#__PURE__*/React.createElement("p", {
      className: "rendering-error__msg"
    }, contextError)));
  }
  return null;
};
export default Error;